export const SPECIAL_KEYS = [
  'Backspace',
  'ArrowLeft',
  'ArrowRight',
  'Del',
  'Delete',
  'Tab',
  'End',
  'Home',
  'Control',
  'Shift'
];

export const ARROW_KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

export const COMBINATION_KEYS = ['c', 'v', 'x', 'a'];

export const DECIMAL_POINT = '.';
